/*
 * File: Store.js
 * Project: mp-mobile-app
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: MST store for Clinical
 */
import { types, flow } from "mobx-state-tree";
import Api, { ClinicalCountsResult } from "./Api";
import PatientIdStorage from "../store/PatientIdStore";

const ClinicalCount = types.model("ClinicalCount", {
  count: types.optional(types.number, 0),
  privilege: types.boolean
});

const Store = types
  .model("Store", {
    keyword: types.optional(types.string, ""),
    loading: false,
    counts: types.map(ClinicalCount)
  })
  .actions(self => ({
    setKeyword(value: string) {
      self.keyword = value;
    },
    fetchClinicalCounts: flow(function*() {
      const patientId = PatientIdStorage.getId();
      if (!patientId) return;
      self.loading = true;
      let res: ClinicalCountsResult;
      try {
        res = yield Api.getClinicalCounts(patientId);
        if (res) {
          for (const key in res) {
            self.counts.set(key, res[key]);
          }
          self.loading = false;
        }
      } catch (e) {
        self.loading = false;
      }
    })
  }));

export default Store;
